import React, { useRef } from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../../util/reactIntl';
import { createResourceLocatorString } from '../../../util/routes';
import CustomSearchForm from './CustomSearchForm/CustomSearchForm';

import css from './SectionHero.module.css';
import { useRouteConfiguration } from '../../../context/routeConfigurationContext';
import routeConfiguration from '../../../routing/routeConfiguration';
import heroImg from '../../../assets/hero-img.png';

const SectionHero = props => {
  const { rootClassName, className, intl, history, viewport } = props;

  const classes = classNames(rootClassName || css.root, className);
  const keywordRef = useRef('');

  const routeConfiguration = useRouteConfiguration();

  const handleSubmit = values => {
    const { location = {}, dates, ...rest } = values;
    const { search, selectedPlace = {} } = location;
    const { bounds } = selectedPlace;
    const searchQuery = {
      address: search,
      dates,
      bounds,
      search,
      ...rest,
    };

    history.push(createResourceLocatorString('SearchPage', routeConfiguration, {}, searchQuery));
  };
  const isMobileLayout = viewport.width && viewport.width > 0 && viewport.width < 768;
  return (
    <div className={classes}>
      <div className={css.heroContent}>
        <div className={css.heroLeftContent}>
          <div className={css.heroInnerContent}>
            <h1 className={css.heroMainTitle}>
              <FormattedMessage id="SectionHero.title" />
            </h1>{' '}
            <CustomSearchForm
              className={css.filterSearchBox}
              onSubmit={handleSubmit}
              intl={intl}
              ref={keywordRef}
              isMobileLayout={isMobileLayout}
              viewport={viewport}
            />
          </div>
        </div>
        {!isMobileLayout && (
          <div className={css.heroRightContent}>
            <img src={heroImg} alt="img" />
          </div>
        )}
      </div>
    </div>
  );
};

SectionHero.defaultProps = { rootClassName: null, className: null };

SectionHero.propTypes = {
  rootClassName: string,
  className: string,
};

export default SectionHero;
